import { useGlobalState } from "@/hooks";
import closeIcon from "/images/close-icon.svg";

export const ReconnectPrompt = () => {
  const { reconnect, setShowReconnectPrompt } = useGlobalState();
  const handleReconnect = () => {
    reconnect({
      newRoom: true,
    });

    setShowReconnectPrompt(false);
  };
  const handleClose = () => {
    setShowReconnectPrompt(false);
  };

  return (
    <div className="flex items-center mt-4 p-4 rounded-xl bg-gray-100 text-gray-800 overflow-visible relative">
      <a
        onClick={handleClose}
        className="absolute top-1 right-1 w-[20px] cursor-pointer h-[20px] rounded-[50%] flex items-center justify-center"
      >
        <img src={closeIcon} alt="close-icon" className="w-[8px] h-[8px]" />
      </a>
      Looks like I went quiet for a second — mind if we reconnect?
      <button
        className="cursor-pointer voice-chat_button inline-block w-fit text-center py-4 px-6 rounded-[1022px] text-white ml-2"
        onClick={handleReconnect}
      >
        Reconnect
      </button>
    </div>
  );
};
